import BackLink from 'components/back-link';
import SwitchTheme from 'components/switch-theme';
import { rem } from 'polished';
import { FC } from 'react';
import styled from 'styled-components';
import { Section, SectionProps } from './section';
import { SectionWrapper } from './section-wrapper';

const StyledSection = styled(Section)<{ wrapperBg?: boolean }>`
  position: relative;
  margin-top: var(--header-height);
  padding: ${({ wrapperBg }) => (wrapperBg ? `${rem(10)} ${rem(30)}` : 0)};
  background: none;
`;

const StyledSectionWrapper = styled(SectionWrapper)<Props>`
  background-color: ${({ wrapperBg, theme }) =>
    wrapperBg ? theme.colors.palette.white : 'transparent'};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ wrapperBg }) =>
    wrapperBg ? '0 4px 45px rgba(0, 0, 0, 0.8)' : 'none'};
`;

const BackLinkWrapper = styled(SectionWrapper)`
  padding: 0 ${rem(10)} ${rem(20)};

  a {
    margin-bottom: 0;
  }
`;

interface Props extends SectionProps {
  wrapperBg?: boolean;
  className?: string;
  backLink?: string;
}

const ContentSection: FC<Props> = ({
  children,
  wrapperBg,
  textAlign,
  className,
  backLink,
}) => {
  return (
    <SwitchTheme to={wrapperBg ? 'dark' : 'light'}>
      <StyledSection
        textAlign={textAlign}
        className={className}
        wrapperBg={wrapperBg}
      >
        {backLink && (
          <BackLinkWrapper>
            <BackLink href={backLink}>Back</BackLink>
          </BackLinkWrapper>
        )}
        <StyledSectionWrapper wrapperBg={wrapperBg}>
          {children}
        </StyledSectionWrapper>
      </StyledSection>
    </SwitchTheme>
  );
};

export default ContentSection;

export const ReminderContent = styled(ContentSection)`
  time {
    margin: 0 0 ${rem(5)};
    font-size: ${rem(14)};
  }

  ${StyledSectionWrapper} {
    color: ${({ theme }) => theme.colors.palette.black};

    > *:last-child {
      margin-bottom: 0;
    }
  }
`;
